import buildingIcon from "../../../resources/building.png";
import placeIcon from "../../../resources/place.png";
import dateIcon from "../../../resources/date-icon.svg";

const ExperienceCard = ({experience, index}) => {
    const gradientColors = [
        'from-blue-500 to-indigo-600',
        'from-indigo-500 to-purple-600', 
        'from-purple-500 to-pink-600',
        'from-pink-500 to-rose-600',
        'from-emerald-500 to-teal-600',
        'from-teal-500 to-cyan-600'
    ];
    
    const bgColors = [
        'from-blue-50/80 to-indigo-50/80',
        'from-indigo-50/80 to-purple-50/80',
        'from-purple-50/80 to-pink-50/80', 
        'from-pink-50/80 to-rose-50/80',
        'from-emerald-50/80 to-teal-50/80',
        'from-teal-50/80 to-cyan-50/80'
    ];

    const selectedGradient = gradientColors[index % gradientColors.length];
    const selectedBg = bgColors[index % bgColors.length];

    return(
        <div className="group relative bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl p-8 shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
            {/* Decorative line */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-slate-900 dark:bg-slate-400 rounded-t-2xl"></div>

            <div className="flex flex-col lg:flex-row justify-between items-start gap-6">
                {/* Main content */}
                <div className="flex-1 space-y-4">
                    <div className="space-y-3">
                        <h3 className="text-2xl font-bold text-slate-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300">
                            {experience.position}
                        </h3>
                        
                        <div className="flex flex-col sm:flex-row gap-4">
                            <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400 font-medium transition-colors duration-300">
                                <div className="p-2 bg-slate-100 dark:bg-slate-700 rounded-lg">
                                    <img src={buildingIcon} className="h-4 w-4 dark:invert" alt="company"/>
                                </div>
                                <span>{experience.company}</span>
                            </div>
                            
                            <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400 font-medium transition-colors duration-300">
                                <div className="p-2 bg-slate-100 dark:bg-slate-700 rounded-lg">
                                    <img src={placeIcon} className="h-4 w-4 dark:invert" alt="location"/>
                                </div>
                                <span>{experience.place}</span>
                            </div>
                        </div>
                    </div>

                    <p className="text-slate-700 dark:text-slate-400 leading-relaxed text-lg font-light transition-colors duration-300">
                        {experience.description}
                    </p>
                </div>

                {/* Side info */}
                <div className="lg:text-right space-y-4">
                    <div className="inline-flex items-center px-4 py-2 bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200 font-semibold rounded-full text-sm">
                        {experience.workingType}
                    </div>
                    
                    <div className="flex lg:justify-end">
                        <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400 font-medium bg-slate-50 dark:bg-slate-900/50 px-4 py-2 rounded-lg border border-slate-200 dark:border-slate-700">
                            <img src={dateIcon} className="h-4 w-4 dark:invert" alt="date"/>
                            <span className="whitespace-nowrap">
                                {experience.start} - {experience.end}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ExperienceCard;